import { Field, Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import RolesSelect from "../../components/common/inputs/RolesSelect";
import { useEffect, useRef, useState } from "react";
import LearnCategoriesSelect from "../../components/common/inputs/LearnCategoriesSelect";
import { learnValidation } from "../../utils/validation/learnValidation";

export default function Learn() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);

  const formHandler = async (values, { resetForm }) => {
    const body = {
      ...values,
      categories,
      roles,
    };
    console.log(body);
    if (categories.length) {
      try {
        if (!location?.state) {
          const response = await postApi({
            path: "admin/learns",
            body: JSON.stringify(body),
          });
          console.log(response);
          successMessage("آموزش با موفقیت اضافه شد");
          resetForm();
        } else {
          const response = await putApi({
            path: `admin/learns/${location?.state.id}`,
            body: JSON.stringify(body),
          });
          console.log(response);
          successMessage("اطلاعات آموزش با موفقیت آپدیت شد.");
        }
        navigate("/learn-list");
      } catch (error) {
        console.error(error);
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("حد اقل یک دسته بندی انتخاب کنید.");
    }
  };

  const roleRef = useRef();

  const [roles, setRoles] = useState([]);

  const handleRoles = (data) => {
    setRoles(data);
  };

  const [categories, setCategories] = useState([]);

  const categoriesRef = useRef();

  console.log(location?.state);

  useEffect(() => {
    if (location?.state?.categories?.length) {
      setCategories(location?.state?.categories);
    }
    if (location?.state?.roles?.length) {
      setRoles(location?.state?.roles);
    }
  }, [location?.state]);

  return (
    <AdminFormLayout title={location?.state ? "ویرایش آموزش" : "افزودن آموزش"} description="اطلاعات آموزش، لینک ویدئو و دسترسی کاربران را تنظیم کنید.">

      <Formik
        enableReinitialize
        initialValues={
          location.state
            ? {
                name: location?.state?.name || "",
                status: location?.state?.status || "active",
                description: location?.state?.description || "",
                link: location?.state?.link || "",
              }
            : {
                name: "",
                status: utils?.LEARN_STATUS_VALUES[0]?.value || "active",
                description: "",
                link: "",
              }
        }
        validationSchema={learnValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder={"نام"}
                  label={"نام"}
                  type="text"
                />

                {utils ? (
                  <Field
                    as="select"
                    name="status"
                    label="وضعیت"
                    component={Select}
                  >
                    {utils?.LEARN_STATUS_VALUES.map((item) => {
                      return <option value={item.value}>{item?.name}</option>;
                    })}
                  </Field>
                ) : null}
                <Input
                  name={"link"}
                  placeholder={"لینک ویدئو"}
                  label={"لینک ویدئو"}
                  type={"textarea"}
                />
                <Input
                  name={"description"}
                  placeholder={"توضیحات"}
                  label={"توضیحات"}
                  type={"textarea"}
                />
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    انتخاب نقش
                  </label>
                  <RolesSelect
                    oldRoles={location?.state?.roles}
                    ref={roleRef}
                    onChange={handleRoles}
                  />
                </div>

                <LearnCategoriesSelect
                  label={"دسته بندی آموزش ها"}
                  oldCategory={location?.state?.categories}
                  ref={categoriesRef}
                  placeholder="انتخاب دسته‌بندی"
                  onChange={setCategories}
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="admin-form-actions">
                  <Button disabled={formik.isSubmitting} loading={formik.isSubmitting} type="submit"
                    text={location?.state ? "ویرایش" : "افزودن"}
                    color={"success"}
                  />
                  <button type="button" className="admin-form-cancel" onClick={() => navigate("/learn-list")}>انصراف</button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </AdminFormLayout>
  );
}
